<template>
  <div class="l_popup">
    <div class="l_popup__panel animation__popup">
      <div class="title">
        <p>あなたのランク情報</p>
      </div>
      <div class="cardrank">
        <div class="image" v-if="this.userRank === '0'">
          <img src="@/assets/img/mypage/card01.png" />
        </div>
        <div class="image" v-else-if="this.userRank === '1'">
          <img src="@/assets/img/mypage/card02.png" />
        </div>
        <div class="image" v-else-if="this.userRank === '2'">
          <img src="@/assets/img/mypage/card03.png" />
        </div>
        <div class="image" v-else-if="this.userRank === '3'">
          <img src="@/assets/img/mypage/card04.png" />
        </div>
        <div class="image" v-else-if="this.userRank === '4'">
          <img src="@/assets/img/mypage/card05.png" />
        </div>
        <div class="image" v-else-if="this.userRank === '5'">
          <img src="@/assets/img/mypage/card06.png" />
        </div>
      </div>
      <div class="timelimit" v-if="this.stampCardExpire !== ''">
        【スタンプカード有効期限】<br />{{ this.stampCardExpire }}まで
      </div>
      <div class="version">
        {{ this.version }}
      </div>
      <div class="l_popup__button">
        <UIButton :label="'閉じる'" @click="tapClose" style="background-color: var(--accent-color);"/>
      </div>
    </div>
  </div>
</template>
<script>
import UIButton from '@/components/UIButton'
import { mapActions } from 'vuex'
import '@/styles/color.css'
export default {
  name: 'RankMorePopup',
  components: {
    UIButton
  },
  props: {
    userType: { type: String, required: true },
    userRank: { type: String, required: true },
    stampCardExpire: { type: String, required: true },
    version: { type: String, required: true }
  },
  computed: {
    ...mapActions('Modal', ['action_toggleModal'])
  },

  created: function() {
    console.log('created')
  },
  methods: {
    tapClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.l_popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_popup__panel {
  position: relative;
  border-radius: 6px;
  border: none;
  background-color: #ffffff;
  width: 280px;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}
.cardrank {
  width: 100%;
  text-align: center;
}

.cardrank .image {
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  width: 98%;
}

.cardrank .image img {
  width: 100%;
}

.title {
  padding-top: 26px;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 16px;
  color: #5a2200;
}

.timelimit {
  padding-top: 13px;
  padding-bottom: 21px;
  font-weight: bold;
  font-size: 14px;
  color: #e03535;
}
.version {
  padding-bottom: 23px;
  font-size: 16px;
  color: #999999;
}

.l_popup__button {
  margin: 18px auto 0;
  padding-bottom: 21px;
  width: 250px;
}



/* close button  */
.l_button__close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
}
</style>
